<template>
  <v-container class="pa-0">
    <v-row no-gutters >
      <v-col class="pa-6" cols="12">
        <form @submit.prevent="verifyPhone" autocomplete="off" v-if="!phoneIsNotVerified && !debtorNotFound">
          <v-row no-gutters  justify="center">
            <v-col cols="12" sm="9">
              <v-text-field name="socSecNr"
                            :label="$t('socSecNr')"
                            @blur="$v.socSecNr.$touch()"
                            id="socSecNr"
                            v-model="socSecNr"
                            :error-messages="socSecNrError"
                            required></v-text-field>
            </v-col>
            <v-col cols="12" sm="9">
              <v-text-field name="phoneNr"
                            prefix="+358"
                            class="long-prefix"
                            placeholder=" "
                            :label="$t('lp-text1-10')"
                            id="phoneNr"
                            @blur="$v.phoneNr.$touch()"
                            v-model="phoneNr"
                            :error-messages="phoneNrError"
                            required></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-btn block tile color="primary" type="submit" :disabled="!formIsValid || loading" :loading="loading">
                {{ $t('lp-text1-9') }}
              </v-btn>
            </v-col>
          </v-row>
        </form>

        <v-row v-if="phoneIsNotVerified">
          <v-col cols="12" class="text-center">
            <h5 class="mt-0 text-h5">{{ $t('lp-text1-1') }}</h5>
          </v-col>
          <v-col cols="12">
            <p class="text-center">{{ $t('lp-text1-2') }}</p>
            <p class="text-center">{{ $t('lp-text1-3') }}</p>
            <p class="text-center">{{ $t('lp-text1-4') }}</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn tile class="success" @click="getAuthenticationUrl">{{ $t('lp-text1-5') }}</v-btn>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn text small @click="phoneIsNotVerified = false">{{ $t('back') }}</v-btn>
          </v-col>
        </v-row>

        <v-row v-if="debtorNotFound">
          <v-col cols="12" class="text-center">
            <h5 class="mt-0 text-h5">{{ $t('lp-text1-6') }}</h5>
          </v-col>
          <v-col cols="12">
            <p class="text-center">{{ $t('lp-text1-8') }}</p>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn text small @click="debtorNotFound = false">{{ $t('back') }}</v-btn>
          </v-col>
        </v-row>

        <v-dialog v-model="showPinCodeDialog" width="780px" max-width="90%">
          <pin-code-dialog :userData="userData" @close="showPinCodeDialog = false"></pin-code-dialog>
        </v-dialog>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PinCodeDialog from './PinCodeDialog.vue'
  import { apiResource } from '@/util/resources'
  import { required, numeric, minLength, maxLength } from 'vuelidate/lib/validators'

  const isValidSSN = (value) => /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d[-U-Y]|[012]\d[A-F])\d{3}[\dA-Z]$/.test(value.toUpperCase())

  export default {
    data: function () {
      return {
        socSecNr: '',
        phoneNr: '',
        phoneIsNotVerified: false,
        showPinCodeDialog: false,
        debtorNotFound: false
      }
    },
    computed: {
      formIsValid () {
        return !this.$v.socSecNr.$error && !this.$v.phoneNr.$error
      },
      loading () {
        return this.$store.getters.loading
      },
      userData () {
        return { Identifier: this.socSecNr, PhoneNumber: '+358' + this.phoneNr }
      },
      socSecNrError () {
        const errors = []
        if (!this.$v.socSecNr.$dirty) return errors
        !this.$v.socSecNr.required && errors.push(this.$t('socSecNrErrors.required'))
        !this.$v.socSecNr.isValidSSN && errors.push(this.$t('socSecNrErrors.invalidSSN'))
        return errors
      },
      phoneNrError () {
        const errors = []
        if (!this.$v.phoneNr.$dirty) return errors
        !this.$v.phoneNr.required && errors.push(this.$t('phoneNrErrors.required'))
        !this.$v.phoneNr.numeric && errors.push(this.$t('phoneNrErrors.numeric'))
        !this.$v.phoneNr.minLength && errors.push(this.$t('phoneNrErrors.length'))
        !this.$v.phoneNr.maxLength && errors.push(this.$t('phoneNrErrors.length'))
        return errors
      }
    },
    methods: {
      verifyPhone () {
        this.$store.commit('setLoading', true)
        this.$store.commit('clearError')
        apiResource.post('api/authentication/verify', this.userData).then((response) => {
          this.$store.commit('setLoading', false)
          this.showPinCodeDialog = false
          this.phoneIsNotVerified = false
          this.debtorNotFound = false

          if (response.data.status === 0) {
            var debtorFound = response.data.responseObject.debtorFound
            var phoneVerified = response.data.responseObject.phoneVerified
            var pinCodeSentOK = response.data.responseObject.pinCodeSentOK

            if (!debtorFound) {
              this.debtorNotFound = true
            } else if (!phoneVerified) {
              this.phoneIsNotVerified = true
            } else if (phoneVerified && pinCodeSentOK) {
              this.showPinCodeDialog = true
            } else if (phoneVerified && !pinCodeSentOK) {
              this.$store.commit('setMessage', { type: 'error', text: 'Pin koodin lähettämisessä virhe.', translate: true })
            }
          } else {
            this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          }
        }).catch((errorResponse) => {
          this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          this.$store.commit('setLoading', false)
        })
      },
      getAuthenticationUrl () {
        var credentials = {
          Identifier: this.socSecNr,
          PhoneNumber: '+358' + this.phoneNr
        }
        this.$store.dispatch('getAuthenticationUrl', credentials)
      }
    },
    components: {
      'pin-code-dialog': PinCodeDialog
    },
    validations: {
      socSecNr: {
        required,
        isValidSSN
      },
      phoneNr: {
        required,
        numeric,
        minLength: minLength(1),
        maxLength: maxLength(12)
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "lp-text1-1": "Ota mobiilikirjautuminen käyttööön",
  "lp-text1-2": "Ole hyvä ja varmista henkilöllisyytesi verkkopankkitunnuksilla aktivoidaksesi mobiilikirjautumisen.",
  "lp-text1-3": "Näin tarvitset jatkossa kirjautumiseen vain henkilötunnuksen ja puhelinnumeron.",
  "lp-text1-4": "Huom! Mikäli puhelinnumerosi vaihtuu, joudut aktivoimaan mobiilikirjautumisen uudelleen.",
  "lp-text1-5": "Siirry tunnistautumaan",
  "lp-text1-6": "Kirjaudu Oma B2 Impact -tunnuksella",
  "lp-text1-8": "Kirjaudu lähettämästämme kirjeestä löytyvillä tunnuksilla asioidaksesi verkkopalvelussamme.",
  "lp-text1-9": "Jatka eteenpäin",
  "lp-text1-10": "Puhelinnumero",
  "socSecNrErrors": {
  "required": "Henkilötunnus on pakollinen.",
  "invalidSSN": "Syötä henkilötunnus muodossa PPKKVV-123X"
  },
  "phoneNrErrors": {
  "required": "Puhelinnumero on pakollinen.",
  "numeric": "Puhelinnumeron tulee olla numero",
  "length": "Puhelinnumeron tulee olla 1-12 numeroa pitkä"
  }
  },
  "se": {
  "lp-text1-1": "Ta mobil inloggning i bruk",
  "lp-text1-2": "Vänligen bekräfta din identitet med nätbankskoder för att ta i bruk mobil inloggning.",
  "lp-text1-3": "På så vis behöver du framöver endast ditt personnummer och telefonnummer för att logga in.",
  "lp-text1-4": "Obs! Om ditt telefonnummer ändrar, bör du aktivera mobilinloggningen på nytt.",
  "lp-text1-5": "Identifiera dig",
  "lp-text1-6": "Logga in med Min B2 Impact ID",
  "lp-text1-8": "Du kan logga in på vår webbtjänst med  Min B2 Impact ID:t som finns i vårt brev.",
  "lp-text1-9": "Fortsätt",
  "lp-text1-10": "Telefonnummer",
  "socSecNrErrors": {
  "required": "Personnumret är obligatoriskt",
  "invalidSSN": "Mata in personnumret i formatet DDMMÅÅ-123X"
  },
  "phoneNrErrors": {
  "required": "Telefonnummer är obligatoriskt",
  "numeric": "Telefonnummer bör vara numeriskt",
  "length": "Telefonnummer bör vara mellan 8-9 tecken"
  }
  },
  "en": {
  "lp-text1-1": "Enable mobile log-in",
  "lp-text1-2": "Please activate mobile log-in by confirming your identity using online banking codes.",
  "lp-text1-3": "Then, in the future, you will only need your personal identification number and phone number to log in.",
  "lp-text1-4": "Please note! If your phone number changes, you will have to activate mobile log-in again.",
  "lp-text1-5": "Identify yourself",
  "lp-text1-6": "Log in using My B2 Impact ID",
  "lp-text1-8": "You can log in to our online service using the case number and My B2 Impact ID provided in our letter.",
  "lp-text1-9": "Continue",
  "lp-text1-10": "Phonenumber",
  "socSecNrErrors": {
  "required": "Personal identification number is mandatory",
  "invalidSSN": "Enter your personal identification number in the form DDMMYY-123X"
  },
  "phoneNrErrors": {
  "required": "Phone number is mandatory",
  "numeric": "Phone number must be numeric",
  "length": "Phone number must be between 8-9 numbers long"
  }
  }
  }
</i18n>
